/**
 * I produksjon ligger frontend (Static Web App) og API-et (Function App) på
 * ulike origins. API-basen settes ved bygg via VITE_API_BASE, og alle relative
 * «/api»-kall rutes dit — uten å endre de mange kall-stedene i koden. Er SSO
 * aktivt, legges også et Entra-access-token på som Bearer.
 *
 * I utvikling er VITE_API_BASE tom og SSO av, så Vite-proxyen håndterer «/api».
 */
import { authEnabled, getApiToken } from "./auth";

const API_BASE = (import.meta.env.VITE_API_BASE ?? "").replace(/\/+$/, "");

export function installApiBase(): void {
  if (!API_BASE && !authEnabled) return;
  const orig = window.fetch.bind(window);
  window.fetch = async (
    input: RequestInfo | URL,
    init?: RequestInit
  ): Promise<Response> => {
    if (typeof input === "string" && input.startsWith("/api")) {
      const headers = new Headers(init?.headers);
      if (authEnabled) {
        const token = await getApiToken();
        if (token) headers.set("Authorization", `Bearer ${token}`);
      }
      return orig(API_BASE + input, { ...init, headers });
    }
    return orig(input, init);
  };
}
